import {
  getDayNumber,
  getMonthYear,
} from "../../../../shared/types/date-helpers";
import { ArrowLeftIcon, ArrowRightIcon } from "../../../../ui/icons";

interface FreeSlotsWeekNavProps {
  readonly firstDay: string;
  readonly lastDay: string;
  onPrevWeek: () => void;
  onNextWeek: () => void;
}

export function FreeSlotsWeekNav({
  firstDay,
  lastDay,
  onPrevWeek,
  onNextWeek,
}: FreeSlotsWeekNavProps) {
  return (
    <div className="flex items-center justify-between">
      <button
        type="button"
        onClick={onPrevWeek}
        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-surface-alt text-ink-muted"
        aria-label="Semaine précédente"
      >
        <ArrowLeftIcon className="w-4 h-4" />
      </button>
      <div className="text-center">
        <div className="text-sm font-semibold text-ink">Créneaux libres</div>
        <div className="text-xs text-ink-muted">
          {getDayNumber(firstDay)} {getMonthYear(firstDay).split(" ")[0]} –{" "}
          {getDayNumber(lastDay)} {getMonthYear(lastDay)}
        </div>
      </div>
      <button
        type="button"
        onClick={onNextWeek}
        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-surface-alt text-ink-muted"
        aria-label="Semaine suivante"
      >
        <ArrowRightIcon className="w-4 h-4" />
      </button>
    </div>
  );
}
